/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';
import { Club } from '../../../modules/wine-club-signup/components/club';
import { Membership } from '../../../modules/wine-club-signup/components/membership';
import { Shipping } from '../../../modules/wine-club-signup/components/shipping';
import { Signup } from '../../../modules/wine-club-signup/components/signup';
import { Variant } from '../../../modules/wine-club-signup/components/variant';
import { WinePreference } from '../../../modules/wine-club-signup/components/wine-preference';
import { IWineClubSignupViewProps } from '../../../modules/wine-club-signup/wine-club-signup';

export namespace ClubViewManager {
    export const renderClubs = (props: IWineClubSignupViewProps) => {
        return (
            <div className='wine-club-signup-club'>
                {/* this is here and NOT in the club because each club is rendered seperately in an ordered list*/}
                <h2 className='wine-club-signup-club-title'>{props.config.chooseClub?.title || props.resources.wineClubSignup__stepOne}</h2>
                {props.config.chooseClub?.subtitle && <RichTextComponent className='wine-club-signup-club-subtitle' text={props.config.chooseClub.subtitle} />}
                <div className='wine-club-signup-club-items'>
                    {props.clubInfo.map((club, idx) => {
                        return (
                            <Club
                                key={idx}
                                club={club}
                                resources={props.resources}
                                id={idx}
                                gridSettings={props.context.request.gridSettings || {}}
                                imageSettings={props.clubImageSettings}
                            />
                        );
                    })}
                </div>
            </div>
        );
    };

    export const shipping = (props: IWineClubSignupViewProps) => {
        return (
            <Shipping
                clubInfo={props.clubInfo}
                props={props}
            />
        );
    };

    export const renderSignup = (props: IWineClubSignupViewProps) => {
        return (
            <React.Fragment>
                <Signup props={props} wineCheckout={props.config.wineCheckout} />
                {props.config.signupText && <RichTextComponent className='wine-club-signup-signup-message' text={props.config.signupText} />}
            </React.Fragment>
        );
    };

    export const winePreference = (props: IWineClubSignupViewProps) => {
        return <WinePreference clubInfo={props.clubInfo} config={props.config} resources={props.resources} />;
    };

    export const variant = (props: IWineClubSignupViewProps) => {
        return (
            <Variant
                clubInfo={props.clubInfo}
                config={props.config}
                resources={props.resources}
                gridSettings={props.context.request.gridSettings || {}}
                imageSettings={props.variantImageSettings}
            />
        );
    };

    export const membershipSelector = (props: IWineClubSignupViewProps) => {
        const {
            wineClubSignup__stepThreeMembership,
        } = props.resources;
        return (
            <fieldset>
                <legend className='sr-only'>{props.config.chooseRecipient?.title || wineClubSignup__stepThreeMembership}</legend>
                <Membership config={props.config} resources={props.resources} />
            </fieldset>
        );
    };

    export const termsAndConditions = (props: IWineClubSignupViewProps) => {
        return (
            <div className='wine-club-signup-terms'>
                <h2 className='wine-club-signup-terms-title'>{props.config.termsConditions?.title || props.resources.wineClubSignup__stepFive}</h2>
                {props.config.termsConditions?.subtitle && <RichTextComponent className='wine-club-signup-terms-subtitle' text={props.config.termsConditions.subtitle} />}
                {props.slots.tos}
            </div>
        );
    };
}

export default (props: IWineClubSignupViewProps) => {
    // enable props.debug to view localstorage data
    return (
        <div className='wine-club-signup'>
            {/* {props.debug} */}
            {props.moduleControl.CHOOSE_CLUB && ClubViewManager.renderClubs(props)}
            {props.moduleControl.CHOOSE_PREFERENCE && ClubViewManager.winePreference(props)}
            {props.moduleControl.SET_MEMBERSHIP && ClubViewManager.variant(props)}
            {props.moduleControl.SET_MEMBERSHIP && ClubViewManager.membershipSelector(props)}
            {props.moduleControl.SET_SHIPPING && ClubViewManager.shipping(props)}
            {props.moduleControl.TERMS && ClubViewManager.termsAndConditions(props)}
            {props.moduleControl.SIGNUP && ClubViewManager.renderSignup(props)}
        </div>
    );
};